import { AfterContentInit, Component,ElementRef, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment, env_data } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-company-register',
  templateUrl: './company-register.component.html',
  styleUrls: ['./company-register.component.css']
})
export class CompanyRegisterComponent implements OnInit{

  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  form: UntypedFormGroup;
  isLoading = false;
  error_status = false;
  error_message = "";
  success_status = false;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private http: HttpClient,
    private fb: FormBuilder,) { 
      //this.authService.validateBusiness(this.businessID)
    }

    get businessName() { return this.form.get('businessName') };
    get vatID() { return this.form.get('vatID') };
    get main_email() { return this.form.get('main_email') };
    get main_phone() { return this.form.get('main_phone') };
    get main_firstName() { return this.form.get('main_firstName') };
    get main_lastName() { return this.form.get('main_lastName') };

    ngOnInit() {
      this.form = this.fb.group({
        businessName: ['', [
          Validators.required,
        ]],
        vatID: ['', [
          Validators.required,
        ]],
        public_leaver: [''],
        main_email: ['', [
          Validators.required, Validators.email,
        ]],
        main_phone: ['', [
          Validators.required,
        ]],
        main_firstName: ['', [
        Validators.required,
        ]],
        main_lastName: ['', [
        Validators.required,
        ]],
  
        ovt:'',
        operator: '',

      }); 
      setTimeout(() => {
      this.addRecaptchaScript();
      },3000);
    }

    validateVatID(){
      //vatID should be 9 digits
      if(this.vatID.value.length != 9){
        alert('Y-tunnus on virheellinen');
        window['grecaptcha'].reset();
        this.error_status = true;
        return;
      }
      //Check that second last digit is a dash
      if(this.vatID.value.charAt(7) != '-'){
        alert('Y-tunnus on virheellinen');
        window['grecaptcha'].reset();
        this.error_status = true;
        return;
      }
      //check that other digits are numbers
      for(var i = 0; i < 7; i++){
        if(isNaN(this.vatID.value.charAt(i))){
          alert('Y-tunnus on virheellinen');
          window['grecaptcha'].reset();
          this.error_status = true;
          return;
        }
      }
    }

    addRecaptchaScript() {
 
      window['grecaptchaCallback'] = () => {
        this.renderReCaptch();
  
        //this.deleteCookies()
      }
   
      var that = this;
      (function(d, s, id, obj){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { obj.renderReCaptch(); return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
        fjs.parentNode.insertBefore(js, fjs);
        
      }(document, 'script', 'recaptcha-jssdk', this));
   
    }

    renderReCaptch() {

    
      let element = this.recaptchaElement.nativeElement;
      window['grecaptcha'].render(element, {
        'sitekey' : env_data.google_site_key,
        'callback': (response) => {
            this.addCompany(response);
            
        }
      });
    }

    showLoader(){
      document.getElementById('loader').style.display = 'block';
    }

    hideLoader(){
      document.getElementById('loader').style.display = 'none';
    }


    addCompany(response) {
      this.showLoader();
      console.log(this.isLoading);

      var pub_leaver = this.form.value.public_leaver;
      if(pub_leaver == 'true' || pub_leaver == true) {
        pub_leaver = true;
      }
      else {
        pub_leaver = false;
      }



      var req = {
        businessName: this.form.value.businessName,
        vatID: this.form.value.vatID,
        public_leaver: pub_leaver,
        response: response,
        user: {
          email: this.form.value.main_email,
          phone: this.form.value.main_phone,
          firstName: this.form.value.main_firstName,
          lastName: this.form.value.main_lastName,
        }
      }

      this.http.post(environment.PUBLIC_BUSINESS_REGISTER, req, this.httpOptions).subscribe(
        (res: any) => {
          this.isLoading = false;
          this.hideLoader();
          
          if(res.status == 200 ) {
            console.log('Successfully added a business');
            this.success_status = true;
            document.getElementById('success_message').style.display = 'block';
            document.getElementById('form-container').style.display = 'none';
            window['grecaptcha'].reset();
          }
          else {
            this.error_status = true;
            if(res.status == 201){
              this.error_message = "Järjestelmävirhe, yritä myöhemmin uudelleen";
              document.getElementById('err-lock').style.display = 'block';
  
            }
            else if(res.status == 202){
              this.error_message = "Rekisteröityminen onnistui, mutta sähköpostiasi ei voitu varmentaa.";
              document.getElementById('err-lock').style.display = 'block';

            }
            else if(res.status == 203){
              document.getElementById('err-lock').style.display = 'block';
              this.error_message = "Rekisteröityminen onnistui, mutta y-tunnusta ei löytynyt PRH:n rekisteristä.";
            }
            else if(res.status == 204){
              document.getElementById('err-lock').style.display = 'block';

              this.error_message = "Rekisteröityminen onnistui, mutta järjestelmä tunnisti sinut botiksi";
            }
            window['grecaptcha'].reset();

            document.getElementById('ss-btn').click()
          }

          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
    }

    faker(){
      console.log('faker');
      //Scroll to top
      window.scrollTo(0, 0);
    }

}
